<template>
  <div
    class="swaggon-recommendation"
    >
    <TrainHead
      class="swaggon-recommendation-helpers"
      v-if="!prev_workpackages"
      :zoom="1"
      />
    <Waggon
      class="swaggon-recommendation-helpers"
      v-else
      :workpackage_count="prev_workpackages.length"
      :zoom="1"
      >
      <template #content>
      <Workpackage
        v-for="(workpackage, index) in prev_workpackages"
        :key="index"
        :workpackage_count="prev_workpackages.length"
        :workpackage="workpackage"
        :zoom="1"
        />
      </template>
    </Waggon>
    <Waggon
      :workpackage_count="recommended_waggon.sworkpackages.length"
      :zoom="1"
      >
      <template #content>
      <Workpackage
        v-for="(workpackage, index) in recommended_waggon.sworkpackages"
        :key="index"
        :workpackage_count="recommended_waggon.sworkpackages.length"
        :workpackage="workpackage"
        :zoom="1"
        />
      </template>
    </Waggon>
    <TrainTail
      class="swaggon-recommendation-helpers"
      v-if="!next_workpackages"
      :zoom="1"
      />
    <Waggon
      class="swaggon-recommendation-helpers"
      v-else
      :workpackage_count="next_workpackages.length"
      :zoom="1"
      >
      <template #content>
      <Workpackage
        v-for="(workpackage, index) in next_workpackages"
        :key="index"
        :workpackage_count="next_workpackages.length"
        :workpackage="workpackage"
        :zoom="1"
        />
      </template>
    </Waggon>
  </div>
</template>
<script>
  import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
  import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
  import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
  import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
  export default {
    props: ['recommended_waggon', 'prev_workpackages', 'next_workpackages'],
    components: {
      TrainHead,
      TrainTail,
      Waggon,
      Workpackage,
    },
    data: () => ({
    }),
  }
</script>
<style>
  .swaggon-recommendation {
    display: flex;
  }
  .swaggon-recommendation-helpers {
    opacity: 0.3;
  }
</style>
